export const USERS_SEARCH_CONTENT_INFO = `В этом архиве бережно хранится информация обо всех пользователях сайта. Введите имя пользователя в поле и нажмите «Поиск».`

export const STATUS_ERROR_MIN_CHARS = `Минимальное количество символов для поиска: 4`

export const STATUS_ERROR_NOTHING_FOUND = `ничего не найдено.`

export const SEARCH_RESULT_INFO = `Результаты поиска для `